module.exports = __webpack_public_path__ + "img/UTTERR.2726b085.png";